import React, { Component } from 'react'
import styled from 'styled-components'
import { apiFetch, uploadToS3, getTheme, toWidth, viewportWidth } from 'helpers'
import { get } from 'lodash'

// Components
import AspectRatioImage, { AspectRatioImageContainer } from 'components/AspectRatioImage'
import { ActionSheets } from 'components/Modal'

// const dRatio = 3.857
const mRatio = 1.5

export default class extends Component {
  constructor (props) {
    super(props)
    this.state = { menusVisible: false }
  }
  _upload = (file, prefix) =>
    apiFetch({
      method: 'POST',
      v4: true,
      url: '/v4/s3/signed-url',
      body: {
        collectionName: 'vendors',
        folderName: get(this.props, 'me._id'),
        fileName: `${prefix}-${new Date().getTime()}.${file.type.split('/').pop()}`,
        fileType: file.type
      }
    })
      .then(({ url }) => uploadToS3({ url, file }))

  _onDesktopCoverChosen = (e) => {
    const file = get(e, 'currentTarget.files.0')
    this.setState({ coverUploading: true }, () =>
      this._upload(file, 'cover-d')
        .then(imageUrl =>
          apiFetch({
            method: 'PUT',
            v4: true,
            url: '/v4/vendors/me',
            body: { coverPath: imageUrl }
          })
            .then(() => this.setState({ coverUploading: false, menusVisible: false }, () => {
              this.props.dispatch({ type: 'SEND_MESSAGE', messageType: 'success', message: 'แก้ไขภาพปกสำเร็จ' })
              this.props.dispatch({ type: 'UPDATE_PROFILE', coverPath: imageUrl })
            }))
            .catch((error) => this.setState({ error, coverUploading: false, menusVisible: false }, () =>
              this.props.dispatch({ type: 'SEND_MESSAGE', messageType: 'error', message: 'แก้ไขภาพปกไม่สำเร็จ, กรุณาลองใหม่อีกครั้ง' })
            ))
        )
    )
  }

  _onMobileCoverChosen = (e) => {
    const file = get(e, 'currentTarget.files.0')
    this.setState({ coverUploading: true }, () =>
      this._upload(file, 'cover-m')
        .then(imageUrl =>
          apiFetch({
            method: 'PUT',
            v4: true,
            url: '/v4/vendors/me',
            body: { rectanglePath: imageUrl }
          })
            .then(() => this.setState({ coverUploading: false, menusVisible: false }, () => {
              this.props.dispatch({ type: 'SEND_MESSAGE', messageType: 'success', message: 'แก้ไขภาพปกสำเร็จ' })
              this.props.dispatch({ type: 'UPDATE_PROFILE', rectanglePath: imageUrl })
            }))
            .catch((error) => this.setState({ error, coverUploading: false, menusVisible: false }, () =>
              this.props.dispatch({ type: 'SEND_MESSAGE', messageType: 'error', message: 'แก้ไขภาพปกไม่สำเร็จ, กรุณาลองใหม่อีกครั้ง' })
            ))
        )
    )
  }

  render () {
    const { me } = this.props
    return (
      <SectionCover>
        <CoverImageContainer>
          <AspectRatioImage ratio={mRatio} src={toWidth(get(me, viewportWidth() > 767 ? 'coverPath' : 'rectanglePath'), (viewportWidth() || 1080))} />
          <BtnEditCover action='edit-cover' onClick={() => this.setState({ menusVisible: true })}>
            <span>อัพเดทรูปปก</span>
          </BtnEditCover>
          <input type='file' ref='desktopChooser' accept='image/*' style={{ display: 'none' }}
            onChange={this._onDesktopCoverChosen} onClick={e => { e.target.value = null }} />
          <input type='file' ref='mobileChooser' accept='image/*' style={{ display: 'none' }}
            onChange={this._onMobileCoverChosen} onClick={e => { e.target.value = null }} />
        </CoverImageContainer>
        <ActionSheets visible={this.state.menusVisible}
          loading={this.state.coverUploading}
          title='เลือกประเภทของรูปปกที่ต้องการแก้ไข'
          onCancel={() => this.setState({ menusVisible: false })}
          options={[
            { key: 'desktop', onClick: () => this.refs.desktopChooser.click(), title: 'Desktop ขนาด 2160x560' },
            { key: 'mobile', onClick: () => this.refs.mobileChooser.click(), title: 'Mobile ขนาด 1500x1000' }
          ]} />
      </SectionCover>
    )
  }
}

const SectionCover = styled.div`
  margin: 0 auto;
  max-width: 1080px;
`
const CoverImageContainer = styled(AspectRatioImageContainer)`
  background-color: ${getTheme`colorImageBackground`};
  @media(min-width: 801px) {
    font-size: 18px;
    padding-bottom: 26%;
  }
  @media(min-width: 480px) and (max-width: 800px) {
    font-size: 16px;
    padding-bottom: 50%;
  }
  @media(max-width: 479px) {
    font-size: 14px;
    padding-bottom: 66.66%;
  }
`
const BtnEditCover = styled.div`
  position: absolute;
  z-index: 10;
  right: 10px;
  bottom: 10px;
  padding: 5px 0px;
  width: 90px;
  text-align: center;
  background-color: white;
  border: 1px solid ${getTheme`colorBorder`};
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  &:hover { background-color: ${getTheme`colorHover`}; }

  > svg {
    height: 16px;
  }

  @media(min-width: 801px) {
    font-size: 16px;
  }
  @media(min-width: 480px) and (max-width: 800px) {
    font-size: 14px;
  }
  @media(max-width: 479px) {
    font-size: 14px;
  }
`



// WEBPACK FOOTER //
// ./src/components/profile/SectionCover.js